import { render, staticRenderFns } from "./twilio-form.vue?vue&type=template&id=bfde2302"
import script from "./twilio-form.vue?vue&type=script&lang=js"
export * from "./twilio-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports